import React, { createContext, useEffect, useState } from 'react'

export const DarkContext = createContext({})

export const DarkProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(false)

    useEffect(() => {
        setIsDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches)

        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

        const handleChange = e => {
            setIsDarkMode(e.matches)
        }

        mediaQuery.addEventListener('change', handleChange)

        return () => {
            mediaQuery.removeEventListener('change', handleChange)
        }
    }, [])

    return <DarkContext.Provider value={{ isDarkMode }}>{children}</DarkContext.Provider>
}
